import { Flex, Typography } from "antd";
import StatusTag from "./status-orders";
import { formatPrice } from "@/utilities";

const { Text } = Typography;

interface StatusSummaryItem {
  status: string;
  count: number;
  total: number;
}

interface StatusSummaryProps {
  orders: any;
}
const ALL_STATUSES = [
  "pending_payment",
  "review",
  "verified",
  "invoiced",
  "processing",
  "preparing",
  "ready_to_deliver",
  "in_shipping",
  "delivered",
  "cancel_request",
  "canceled",
];

export const StatusSummary: React.FC<StatusSummaryProps> = ({ orders }) => {
  const getStatusSummary = (): StatusSummaryItem[] => {
    const summaryMap = new Map<string, { count: number; total: number }>();

    // Initialize with default statuses
    ALL_STATUSES.forEach((status) => {
      summaryMap.set(status, { count: 0, total: 0 });
    });

    // Add an 'other' category
    summaryMap.set("other", { count: 0, total: 0 });

    // Process each order
    orders.forEach((order: any) => {
      const status = order.status;
      const amount = order.grandTotal || 0;

      if (ALL_STATUSES.includes(status)) {
        const current = summaryMap.get(status)!;
        summaryMap.set(status, {
          count: current.count + 1,
          total: current.total + amount,
        });
      } else {
        // Add to 'other' category
        const other = summaryMap.get("other")!;
        summaryMap.set("other", {
          count: other.count + 1,
          total: other.total + amount,
        });
      }
    });

    // Convert to array and filter out statuses with 0 count
    const result = Array.from(summaryMap.entries())
      .map(([status, data]) => ({
        status,
        count: data.count,
        total: data.total,
      }))
      .filter((item) => (item.status === "other" ? item.count > 0 : true)); // Only show 'other' if it has items

    return result;
  };

  const statusSummary = getStatusSummary();

  const Div = <div style={{ width: 60, textAlign: "center" }}> -</div>;

  return (
    <>
      {statusSummary.map((item) => (
        <Flex
          key={item.status}
          justify="space-between"
          style={{ width: "100%" }}
        >
          <StatusTag status={item.status} />
          <Flex gap={4}>
            <Text type="secondary">{item.count} x </Text>
            <Text strong>
              {item?.total === 0 ? Div : formatPrice(item?.total)}
            </Text>
          </Flex>
        </Flex>
      ))}
    </>
  );
};
